import { LessonWidgetRendererData } from "@haohan/lesson";

export interface Page {
    title?: string;
    shortTitle?: string;
    id: string;
    widgets: LessonWidgetRendererData[];
}

export class LessonModel {
    title: string;
    description: string;
    timing?: number
    labels?: {
        color: string,
        title: string
    }[];
    pages: Page[];
}

export class LessonI18nModel {
    id: number;
    items: {
        en?: LessonModel;
        ru?: LessonModel;
    }
}
